module.exports = __webpack_public_path__ + "public/img/newDay.3e605d42.png";